import { useState } from "react";
import { MessageSquare, X, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function LiveChat() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    { from: "agent", text: "Hi! I'm Nova from Finzpe support. How can I help today?" },
  ]);
  const [text, setText] = useState("");

  const send = () => {
    if (!text.trim()) return;
    const q = text.trim();
    setMsgs((m) => [...m, { from: "you", text: q }]);
    setText("");
    setTimeout(() => {
      setMsgs((m) => [
        ...m,
        { from: "agent", text: "Thanks for reaching out! An agent will respond shortly. Meanwhile, check our FAQs for quick answers." },
      ]);
    }, 700);
  };

  return (
    <>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="livechat-toggle"
        className="fixed bottom-24 right-6 z-40 h-14 w-14 rounded-full flex items-center justify-center text-white shadow-lg hover:scale-105 transition-transform brand-gradient"
        aria-label="Open live chat"
      >
        {open ? <X className="h-6 w-6" /> : <MessageSquare className="h-6 w-6" />}
      </button>
      {open && (
        <div className="fixed bottom-44 right-6 z-40 w-[340px] max-w-[92vw] rounded-2xl glass overflow-hidden" data-testid="livechat-panel">
          <div className="brand-gradient px-4 py-3 text-white">
            <div className="font-display font-semibold">Finzpe Support</div>
            <div className="text-xs opacity-90">Typically replies in a few minutes</div>
          </div>
          <div className="p-4 space-y-2 max-h-72 overflow-y-auto bg-background/70">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.from === "you" ? "justify-end" : "justify-start"}`}>
                <div className={`px-3 py-2 rounded-2xl text-sm max-w-[80%] ${m.from === "you" ? "bg-primary text-primary-foreground" : "bg-muted"}`}>
                  {m.text}
                </div>
              </div>
            ))}
          </div>
          <div className="p-2 border-t border-border flex items-center gap-2 bg-background">
            <Input
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Type a message..."
              data-testid="livechat-input"
            />
            <Button size="icon" onClick={send} data-testid="livechat-send"><Send className="h-4 w-4" /></Button>
          </div>
        </div>
      )}
    </>
  );
}
